module.exports = __webpack_public_path__ + "static/media/lilarrow.b8ae4665.svg";